import script from "./LegalPeople.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalPeople.vue?vue&type=script&setup=true&lang=js"

import "./LegalPeople.vue?vue&type=style&index=0&id=7676d8c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7676d8c2"]])

export default __exports__